import OpenReplayTracker from '@openreplay/tracker';

class TrackerService
{
    tracker = null;
    constructor()
    {
        this.tracker = null;
    }

    init( config )
    {
        const trackerConfig = 
        {
            projectKey: config.projectKey,
            ingestPoint: config.ingestPoint,
            inlineCss: 3,
            defaultInputMode: 0,
            obscureTextNumbers: false,
            obscureTextEmails: false,
            obscureInputEmails: false
        }

        this.tracker = new OpenReplayTracker( trackerConfig );
    }

    start()
    {
        if( !this.tracker ){ return; }
        
        this.tracker.start();
    }
    
    stop()
    {
        if( !this.tracker ){ return; }

        this.tracker.stop();
        sessionStorage.removeItem( '__openreplay_token' );
        sessionStorage.removeItem( '__openreplay_tabid' );
        sessionStorage.removeItem( '__openreplay_pageno' );
        localStorage.removeItem( '__openreplay_uuid' );
    }

    setUser( userId )
    {
        if( !this.tracker ){ return; }

        this.tracker.setUserID( userId )
    }
    
    setMetadata( key, value )
    {
        if( !this.tracker ){ return; }

        this.tracker.setMetadata( key, value );
    }

    getSessionToken()
    {
        if( !this.tracker ){ return; }

        this.tracker.getSessionToken();
    }
}
const trackerService = new TrackerService();

export default trackerService;
